import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

/**
 * Returns true if the event is a meeting and the current user is the organizer
 * @param item calendar item object
 */
export default function isMeetingAttendee(item: CalendarEvent): boolean {
    return item && item.IsMeeting && !item.IsOrganizer;
}
